import axios from 'axios';
import router from '@/router';
import {Message} from 'element-ui';
import store from '../store/index';

const service = axios.create({
    timeout: 1000 * 12000,
    withCredentials: true,
    xsrfHeaderName: 'Authorization',
    headers: {
        'Content-Type': 'application/json; charset=utf-8',
    }
});

service.interceptors.request.use(
    config => {
        if (sessionStorage.getItem('JSESSIONID')) {
            config.headers.Authorization = sessionStorage.getItem('JSESSIONID');
        }
        if (sessionStorage.getItem('siteClassification')) {
            config.headers.siteClassification = sessionStorage.getItem('siteClassification');
        }
        const langConfig = {
            en:'en-US,en;q=0.9,en-GB;q=0.8',
            zh:'zh-CN'
        }
        const lang = localStorage.getItem('lang') ? localStorage.getItem('lang'):'zh'
        config.headers['Accept-Language'] =  langConfig[lang]
        return config;
    },
    error => {
        console.error(error);
        return Promise.reject(error);
    }
);

service.interceptors.response.use(
    response => {
        if (response.data.code === 'FILE_UPLOAD_007') {
            window.vm.$t('FILE_UPLOAD_007')
        }
        return response.data;
    },
    error => {
        //最后统一处理
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    sessionStorage.removeItem('JSESSIONID');
                    localStorage.removeItem('JSESSIONID')
                    if (store.state.common.user.userType == '2') {
                        router.replace({name: 'login'});
                    } else {
                        // store.state.common.siteInfo = {}
                        // sessionStorage.setItem('redirectUrl', JSON.stringify({name: router.currentRoute.name})); //内部用户记录失效的url,重新登陆后自动跳转
                        router.replace({name: 'home'});
                    }
                    break;
                case 400:
                    Message.error('bad request！');
                    break;
                case 403:
                    Message.error(window.vm.$t(error.response.data.code));
                    break;
                case 500:
                    Message.error('servers error！');
                    break;
                // router.replace('/login')
            }
        }
    }
);

const _serviceWithHeader = axios.create({
    timeout: 1000 * 12000,
    withCredentials: true,
    xsrfHeaderName: 'Authorization',
    headers: {
        'Content-Type': 'application/json; charset=utf-8',
    }
});

_serviceWithHeader.interceptors.request.use(
    config => {
        if (sessionStorage.getItem('JSESSIONID')) {
            config.headers.Authorization = sessionStorage.getItem('JSESSIONID');
        }
        if (sessionStorage.getItem('siteClassification')) {
            config.headers.siteClassification = sessionStorage.getItem('siteClassification');
        }
        const langConfig = {
            en:'en-US,en;q=0.9,en-GB;q=0.8',
            zh:'zh-CN'
        }
        const lang = localStorage.getItem('lang') ? localStorage.getItem('lang'):'zh'
        config.headers['Accept-Language'] =  langConfig[lang]
        return config;
    },
    error => {
        console.error(error);
        return Promise.reject(error);
    }
);

_serviceWithHeader.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        //最后统一处理
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    sessionStorage.removeItem('JSESSIONID');
                    localStorage.removeItem('JSESSIONID')
                    if (store.state.common.user.userType == '2') {
                        router.replace({name: 'login'});
                    } else {
                        // store.state.common.siteInfo = {}
                        // sessionStorage.setItem('redirectUrl', JSON.stringify({name: router.currentRoute.name})); //内部用户记录失效的url,重新登陆后自动跳转
                        router.replace({name: 'home'});
                    }
                    break;
                case 400:
                    Message.error('bad request！');
                    break;
                case 403:
                    Message.error(window.vm.$t(error.response.data.code));
                    break;
                case 500:
                    Message.error('servers error！');
                    break;
                // router.replace('/login')
            }
        }
    }
);

export const serviceWithHeader = _serviceWithHeader
export default service;
